import React from "react";


export default function PopupDisplay(props) {

    return (
        props.isPopupOpen &&
        <div className="absolute flex top-0 left-0 bottom-0 right-0 z-10 bg-city-white/80">
            <div className="w-full md:w-1/2 m-auto bg-white">
                <div className="px-2 w-full border-bottom justify-between flex bg-city-green-dark text-city-white ">
                    <h6 className="font-weight-bold">{props.title}</h6>
                    <button type="button" className="text-city-yellow-medium" onClick={() => props.setIsPopupOpen(false)}>
                        X
                    </button>
                </div>

                <div className="bg-city-green-medium/40">
                    <div className="p-3">{props.children}</div>
                </div>
                <div className="text-city-white bg-city-green-medium hover:text-city-yellow-medium hover:bg-city-green-dark rounded-sm px-2 py-0.5 cursor-pointer" onClick={() => props.setIsPopupOpen(false)}>
                            Close
                </div>
            </div>
        </div>
    )
}